import Router from 'vue-router';
import Util from '../../lib/utils';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex';
import Vuex from 'vuex';
import ajax from '../../lib/ajax';
import sissconst from '../../lib/sissconst';
import { router } from '@/router/router';
Vue.use(Vuex);
interface AppState {
  cachePage: any[];
  lang: string;
  isFullScreen: boolean;
  openedSubmenuArr: any[];
  menuTheme: string;
  themeColor: any;
  mallNavbar: any;
  pageOpenedList: any[];
  currentPageName: string;
  currentPath: any[];
  menuList: any[];
  routers: any[];
  tagsList: any[];
  messageCount: number;
  dontCache: any[];
  noticeList: any[];
  enshopid: string;
}
class AppModule implements Module<AppState, any> {
  public namespaced = true;
  //console.log(Util)
  public enshopid = Util.siss.auth.getenshopid();
  public state = {
    cachePage: [],
    lang: '',
    isFullScreen: false,
    openedSubmenuArr: [],
    menuTheme: 'dark',
    themeColor: sessionStorage[this.enshopid + '_themeColor'] ? JSON.parse(sessionStorage[this.enshopid + '_themeColor']) : { c1: "#FF4444", c2: "#FF8755", c3: "#fff", c4: "#FF4444" },
    mallNavbar: sessionStorage[this.enshopid + '_mallNavbar'],
    pageOpenedList: [{
      meta: { title: '首页' },
      path: '',
      name: 'home',
    }],
    currentPageName: '',
    currentPath: [
      {
        meta: { title: '首页' },
        path: '',
        name: 'home',
      },
    ],
    menuList: [],
    routers: [
      Router,
    ],
    tagsList: [Router],
    messageCount: 0,
    dontCache: [],
    // tslint:disable-next-line:max-line-length
    noticeList: [{ read: false, type: 0, title: 'First notice', description: 'One day ago' }, { read: false, type: 1 }, { read: false, type: 0, title: 'Second notice', description: 'One month ago' }],
    enshopid: Util.siss.auth.getenshopid(),
  };
  public mutations = {
    logout(state: AppState) {
      localStorage.clear();
      sessionStorage.clear();
    },
    setTagsList(state: AppState, list: any[]) {
      state.tagsList.push(...list);
    },
    updateMenulist(state: AppState) {
      const menuList: any[] = [];
      state.menuList = menuList;
    },
    changeMenuTheme(state: AppState, theme: string) {
      state.menuTheme = theme;
    },
    changeMainTheme(state: AppState, mainTheme: any) {
      console.log('mainTheme', mainTheme)
      if (!mainTheme.c3 || !mainTheme.c4) {
        mainTheme.c3 = '#fff';
        mainTheme.c4 = mainTheme.c1;
      }
      state.themeColor = mainTheme;
      const enshopid = Util.siss.auth.getenshopid();
      sessionStorage.setItem(enshopid + "_themeColor", JSON.stringify(mainTheme));
    },
    changeMallNavbar(state: AppState, mallNavbar: any) {
      state.mallNavbar = mallNavbar;
      const enshopid = Util.siss.auth.getenshopid();
      sessionStorage.setItem(enshopid + "_mallNavbar", mallNavbar);
    },
    addOpenSubmenu(state: AppState, name: any) {
      let hasThisName = false;
      let isEmpty = false;
      if (name.length === 0) {
        isEmpty = true;
      }
      if (state.openedSubmenuArr.indexOf(name) > -1) {
        hasThisName = true;
      }
      if (!hasThisName && !isEmpty) {
        state.openedSubmenuArr.push(name);
      }
    },
    closePage(state: AppState, name: any) {
      state.cachePage.forEach((item, index) => {
        if (item === name) {
          state.cachePage.splice(index, 1);
        }
      });
    },
    initCachepage(state: AppState) {
      if (localStorage.cachePage) {
        state.cachePage = JSON.parse(localStorage.cachePage);
      }
    },
    removeTag(state: AppState, name: string) {
      state.pageOpenedList.map((item, index) => {
        if (item.name === name) {
          state.pageOpenedList.splice(index, 1);
        }
      });
    },
    pageOpenedList(state: AppState, get: any) {
      const openedPage = state.pageOpenedList[get.index];
      if (get.argu) {
        openedPage.argu = get.argu;
      }
      if (get.query) {
        openedPage.query = get.query;
      }
      state.pageOpenedList.splice(get.index, 1, openedPage);
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    clearAllTags(state: AppState) {
      state.pageOpenedList.splice(1);
      state.cachePage.length = 0;
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    clearOtherTags(state: AppState, vm: Vue) {
      const currentName = vm.$route.name;
      let currentIndex = 0;
      state.pageOpenedList.forEach((item, index) => {
        if (item.name === currentName) {
          currentIndex = index;
        }
      });
      if (currentIndex === 0) {
        state.pageOpenedList.splice(1);
      } else {
        state.pageOpenedList.splice(currentIndex + 1);
        state.pageOpenedList.splice(1, currentIndex - 1);
      }
      const newCachepage = state.cachePage.filter((item) => {
        return item === currentName;
      });
      state.cachePage = newCachepage;
      localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
    },
    setOpenedList(state: AppState) {
      // tslint:disable-next-line:max-line-length
      // state.pageOpenedList = localStorage.pageOpenedList ? JSON.parse(localStorage.pageOpenedList) : [otherRouters.children[0]];
    },
    setCurrentPath(state: AppState, pathArr: any[]) {
      state.currentPath = pathArr;
    },
    setCurrentPageName(state: AppState, name: string) {
      state.currentPageName = name;
    },
    clearOpenedSubmenu(state: AppState) {
      state.openedSubmenuArr.length = 0;
    },
    increateTag(state: AppState, tagObj: any) {
      if (!Util.oneOf(tagObj.name, state.dontCache)) {
        state.cachePage.push(tagObj.name);
        localStorage.cachePage = JSON.stringify(state.cachePage);
      }
      state.pageOpenedList.push(tagObj);
    },
  };
  public actions = {
    async login(content: ActionContext<AppState, any>, payload: any) {
      const rep = await ajax.post('/api/TokenAuth/AuthenticateMobile', payload.data);
      if (rep.data.result) {
        const tokenExpireDate = payload.data.rememberMe ? (new Date(new Date().getTime() + 1000 * rep.data.result.expireInSeconds)) : undefined;
        Util.siss.auth.setToken(rep.data.result.accessToken, tokenExpireDate);
        Util.siss.utils.setCookieValue(sissconst.authorization.encrptedAuthTokenName, rep.data.result.encryptedAccessToken, tokenExpireDate, Util.siss.sissPath);
        Util.siss.auth.setuserToken(rep.data.result.user_Ticket, tokenExpireDate);
        Util.siss.auth.setshopid(rep.data.result.enshopid);
        localStorage.setItem(rep.data.result.enshopid + '_shopinfo', JSON.stringify(rep.data.result.shopInfo));
        // 开启购物商城
        localStorage.setItem(rep.data.result.enshopid + '_is_open_shopping_mall', JSON.stringify(rep.data.result.shopInfo.is_open_shopping_mall))
        if (!rep.data.result.shopInfo.is_open_shopping_mall) {
          router.push('/endshopmall')
        }
        let param = await Util.buildLoginLog()
        console.log('param===', param)
        ajax.get('/minimall/statistics-service/log.gif', {params: param}).then(res => {
          console.log(res)
        })
        return rep.data.result.userInfo;
      }
    }
  };
}
const appModule = new AppModule();
export default appModule;
